module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-partners/view-partners.component.css
// module id = ./src/app/view-partners/view-partners.component.css
// module chunks = main